<template>
	<BaseModal
      :ok-only="true"
      :status.sync="status"
      :modal-ref-name="modalRefName"
      :hide-header-close="!showModalDocumentStyleCloseButton"
      @close="modalClose"
  >
		<template #title>
			{{ $t("Quel look voulez-vous pour vos factures ?") }}
		</template>

		<template #default>
      <b-container class="p-0 m-0">
        <b-row>
          <b-col cols="12 mb-3">
            <b>{{ $t("Choisir un modèle") }}</b>
          </b-col>

          <b-col cols="12" class="p-0 m-0">
            <div class="carousel_container">
              <!-- carousel -->
              <div
                  class="position-absolute top-0 left-0 w-100 h-100"
                  style="pointer-events: auto;"
              >
                <embla-carousel
                    :models="models"
                    :selected-model="selectedModel"
                    :selected-model-index="selectedModelIndex"
                    @preview="showPreview"
                    @selected="selectModel"
                />
                <b-modal ref="preview" hide-footer hide-title>
                  <b-img-lazy fluid-grow :src="selectedPreview" />
                </b-modal>
              </div>
              <!-- color picker -->
              <div
                  v-if="openedPicker"
                  class="position-absolute top-0 right-0 w-100 h-100"
              >
                <div
                    class="d-flex align-items-end w-100 h-100 justify-content-end pr-2"
                    style="background-color: rgba(255, 255, 255, 0.8)"
                >
                  <Sketch
                      :value="selectedColor"
                      :disable-alpha="true"
                      @input="selectedColor = $event.hex"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <div class="text-muted">{{$t('Modele visible apres sauvegarde')}}</div>
        </b-row>

        <b-row>
          <hr class="separator" />
        </b-row>
        <b-row>
          <b-col cols="12">
            <b>{{ $t("Choisir une couleur") }}</b>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-button
                v-for="({ value }, index) in colors"
                :key="index"
                class="btn-color mt-3"
                :style="`background-color: ${value}`"
                :class="[
                  index > 0 ? 'space-15' : '',
                  selectedColor === value ? 'blue-border' : 'grey-border'
                ]"
                @click="selectedColor = value"
              />

              <b-button
                block
                class="btn-color space-15 grey-border ml-4"
                style="padding: 0; width: 2.5rem; height: 2.5rem; margin-top: 0.85rem"
                :style="
                  selectedColor
                    ? `background-color: ${selectedColor}`
                    : `background-color:  white`
                "
                @click="openedPicker = !openedPicker"
              >
                <div
                  :style="{
                    'background-color': selectedColor,
                    color: colorTable
                  }"
                />

                <b-icon
                  icon="pencil"
                  :color="colorTable"
                  font-scale="1.3"
                  style="margin-left: 3px"
                />
              </b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
		</template>

		<template #footer>
			<hr class="separator" />
			<s-button type="" @click="handleSubmit"> {{ showModalDocumentStyleCloseButton ? $t("Enregistrer") : $t("Suivant") }} </s-button>
		</template>
	</BaseModal>
</template>

<script>
	import { Sketch } from "vue-color";
	import { mapState } from "vuex";
	import { query } from "@sinao/core-js";
  import EmblaCarousel from "./EmblaCarousel.vue"

	export default {
		name: "ModalDocumentStyle",
		components: {
			Sketch,
      EmblaCarousel
		},
		props: {},
		data() {
			return {
				modalRefName: "ModalDocumentStyle",
				selectedPreview: null,
				openedPicker: null,
				templatesLoaded: false,
				colors: [
					{ text: "A", value: "#2469ff" },
					{ text: "B", value: "#35ca81" },
					{ text: "C", value: "#7f43ff" },
					{ text: "D", value: "#fd3130" },
					{ text: "E", value: "#f08500" },
					{ text: "F", value: "#bb6bd9" },
					{ text: "G", value: "#000000" }
				],
				models: [],
        selectedModelIndex: 0,
        selectedColor: this.$store.state?.settings?.accentColor?.background ?? "#3974d2"
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
        showModalDocumentStyleCloseButton: state => state.onboarding.showModalDocumentStyleCloseButton
			}),
			status: {
				get() {
					return this.$store.state.onboarding.showModalDocumentStyle && this.templatesLoaded;
				},
				set(value) {
					this.$store.commit("showModalDocumentStyle", value);
				}
			},
			colorTable() {
				return this.calculateTextColor(this.selectedColor);
			},
			backgroundTable: {
				get() {
					return this.$store.state.settings.accentColor.background;
				},
				set(value) {
					// background = primary
					// foreground = color-second-text
					this.$store.commit("color", { slot: "background", color: value });
					this.$store.commit("color", { slot: "foreground", color: this.colorTable });
				}
			},
      selectedModel: {
        get() {
          return this.$store.state.settings?.config?.template?.model ?? "default";
        },
        set(value) {
          this.$store.commit("configTemplateModel", value);
        }
      }
		},
		async mounted() {
			await this.loadTemplates();
      const index = this.models.findIndex(model => model.id === this.selectedModel);
      if (index !== -1) {
        this.selectedModelIndex = index;
      }
		},
		methods: {
			async loadTemplates() {
				const { appId } = this;
				try {
					const { data } = await query({
						operationId: "app.settings.templates.list",
						params: {
							appId,
						}
					});
					this.models = [...data];
					this.templatesLoaded = true;
				} catch (error) {
					console.error("Erreur lors du chargement des modèles:", error);
					 // Permettre l'affichage même en cas d'erreur
					this.templatesLoaded = true;
					this.models = [
						{ img_url: "https://sinao.app/front/assets/images/invoices/default.png", id: "default" },
						{ img_url: "https://sinao.app/front/assets/images/invoices/tpl-1.png", id: "tpl-1" },
						{ img_url: "https://sinao.app/front/assets/images/invoices/tpl-2.png", id: "tpl-2" },
						{ img_url: "https://sinao.app/front/assets/images/invoices/tpl-3.png", id: "tpl-3" },
						{ img_url: "https://sinao.app/front/assets/images/invoices/tpl-4.png", id: "tpl-4" },
						{ img_url: "https://sinao.app/front/assets/images/invoices/tpl-5.png", id: "tpl-5" }
					];
				}
			},
			selectModel(value) {
				this.selectedModel = value;
			},
			showPreview(link) {
				this.selectedPreview = link;

				this.$refs["preview"].show();
			},
			handleSubmit() {
				const { appId } = this;

        this.backgroundTable = this.selectedColor;

				query({
					operationId: "app.settings.update",
					params: {
						appId
					},
					data: {
						settings: {
							"template.model": this.selectedModel,
							"template.color-primary": this.backgroundTable,
							"template.color-second": this.backgroundTable,
							"template.color-second-text": this.colorTable,
							"installation.onboarding.showModalDocumentStyle": 1,
              "installation.onboarding-app.document_template": {id: this.selectedModel, color: this.backgroundTable}
            }
					}
				});

        if (this.showModalDocumentStyleCloseButton) {
          this.modalClose();
        } else {
          this.next();
        }
			},
			next() {
				this.status = false;

        this.$store.commit("setPopovers", { key: "showModalDocumentStyle", value: false });
        this.$nextTick(() => this.$store.dispatch('setNextOpenedPopover') );

				query({
					operationId: "app.settings.update",
					params: {
						appId: this.appId
					},
					data: {
						settings: {
							"installation.onboarding.showModalDocumentStyle": 1,
						}
					}
				});
			},
      modalClose() {
        this.$store.commit("showModalDocumentStyle", false);
        this.$store.commit("showModalDocumentStyleCloseButton", false);
      }
		}
	};
</script>

<style lang="scss">
	.btn-color {
		display: inline-block;
		width: 35px;
		height: 35px;
		border-radius: 50%;
		cursor: pointer;
	}
  .carousel_container {
    position: relative;
    min-height: 24rem
  }

  @media (max-width: 576px) {
    .carousel_container {
      min-height: 20rem
    }
  }

  @media (min-width: 768px) {
    .carousel_container {
      min-height: 24rem
    }
  }
</style>
